export default __webpack_public_path__ + "static/express-interest-2c850ac7e01bfd852d9305ecf188a421.jpg";